const turkish = {
  default: [
    '" 1 2 3 4 5 6 7 8 9 0 * - # {bksp}',
    "{tab} q w e r t y u ı o p ğ ü [ ]",
    "{lock} a s d f g h j k l ş i , {enter}",
    "{shift} < z x c v b n m ö ç . | $ € {shift}",
    ".com @ {space}"
  ],
  shift: [
    "é ! ' ^ + % & / ( ) = ? _ ~ {bksp}",
    "{tab} Q W E R T Y U I O P Ğ Ü { }",
    "{lock} A S D F G H J K L Ş İ ; {enter}",
    "{shift} > Z X C V B N M Ö Ç : \\ ` ´ {shift}",
    ".com @ {space}"
  ]
};

export default turkish;
